define([
	"dojo/has",
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/locale",
	"csi/sessionConstants"
], function(has, def, Action, ActionFactory, locale, sessionConstants) {

	return ActionFactory.declare("pdf", Action, {
		m_id: "ViewPdf",
		m_class: "far fa-fw fa-file-pdf",

		constructor: function() {
			this.m_typeControl = def.ACTION_ICON;
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: disable if data size is empty, or larger than max data size allowed for use
			return ctx.view.hasContent() && !ctx.view.doesQueryTotalExceedMax() && this.inherited(arguments);
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			// summary: add max limit to tooltip
			this.inherited(arguments);

			const max = sessionConstants.siteMaxExportSize;
			if (max) {
				this.m_tooltip = locale.tooltip(this.m_id + "Max", [max]);
			}
		},

		validate: function(/*Context*/ctx) {
			// summary: allow PDF export when not printing, not in popup, and not in child view of a composite view
			var view = ctx.view.getToolbarContainerView();
			return !ctx.bPrint && !ctx.view.bPopup && (!view || !view.toolbarNode || (view == ctx.view));
		}
	});
});